import React from "react";
import ReactTable from "accessible-react-table";
import CellInput from "./cellInput";
import withProps from "../helpers/withProps";
import "react-table/react-table.css";

const TimesheetHeadingsTable = ({
  rows,
  updateRows,
  saving,
  saveChanges,
  loading,
  saveError
}) => {
  const CellInputWithRows = withProps({ rows, updateRows })(CellInput);
  const columns = [
    {
      Header: "Description",
      accessor: "HeadingName",
      width: 200
    },
    {
      Header: "New Description",
      accessor: "HeadingLabel",
      Cell: CellInputWithRows
    }
  ];

  return (
    <div>
      <h4 className="tw-text-xl tw-py-4 tw-font-bold">
        Customise Rate Descriptions
      </h4>
      <p className="tw-pb-4">
        To customise the rate descriptions in the reports please fill in the new
        description fields in the table below.
      </p>
      <div className="col-lg-8">
        <ReactTable
          loading={loading}
          data={rows}
          showPagination={true}
          defaultPageSize={10}
          minRows={0}
          columns={columns}
        />
      </div>
      {saveError && (
        <p style={{ marginTop: "-1rem", marginBottom: "3rem", color: "red" }}>
          {saveError}
        </p>
      )}
      <button
        className="btn btn-primary"
        onClick={saveChanges}
        disabled={saving}
        style={{ marginTop: "-2em", marginBottom: "3em" }}
      >
        {saving ? "Saving..." : "Save Changes"}
      </button>
    </div>
  );
};

export default TimesheetHeadingsTable;
